import React, { useState } from 'react'
import GalleryFrame from '../gallery-frame/GalleryFrame'
import { Categories } from '../../constants/categories';
import Styles from "../CommonGallery.module.scss"

import { Videos } from '../../data/video';
import classnames from 'classnames';

import { ReactComponent as PlayIcon } from "../../images/icons/play.svg";
interface VideoProps {
  theme: string;
  category: string
  isEditing:boolean;
  onEditClick:()=>void;
}

const Video = ({ theme, category,isEditing,onEditClick }: VideoProps) => {

  const [image, setImage] = useState("https://www.youtube.com/embed/bx-0YlFprqc")
  const [page, setPage] = useState(1)
  const [imageIndex, setImageIndex] = useState(-1)
  const pageLimit = Categories.TRAVEL.perPageLimit;

  const handleImageClick = (url: string, index: number) => {
    setImageIndex(index)
    setImage(url)
  }

  const handlePageClick = (pageNumber: number) => {
    setPage(pageNumber)
  }

  const getPhotos = () => {
    return (<div className={Styles.video_gallery}>

      {Videos.slice(((page - 1) * pageLimit), page * pageLimit).map((video, index: number) => {
        return (
          <div className={imageIndex === index ? classnames(Styles.video_card, Styles.active_video) : Styles.video_card} onClick={() => { handleImageClick(video.videoUrl, index) }}>


            <img src={video.thumbnailUrl} loading={"lazy"} />

            <div className={Styles.info_container}>
              <div className={Styles.title}>{video.title}</div>
              <div className={Styles.description}>
                {video.description}
              </div>
              <div className={Styles.description}>
                Duration : {video.duration}
              </div>
            </div>


            {
              imageIndex === index && (
                <div className={Styles.play_container}>


                  <PlayIcon width={15} height={15} />
                </div>

              )
            }



          </div>
        )
      })}

    </div>
    )
  }


  return (
    <div>
      <GalleryFrame
        mainImage={image}
        category={category}
        theme={theme}
        photosGallery={getPhotos()}
        numberOfPages={Videos.length / pageLimit }
        currentPage={page}
        pageClick={handlePageClick}
        isEditing={isEditing}
        onEditClick={onEditClick}
      />
    </div>
  )

}


export default Video
